export function recruitRequirements() {
  const engineerTab = document.querySelector('.p-recruit-requirements__tab--engineer');
  const directorTab = document.querySelector('.p-recruit-requirements__tab--director');
  const engineerAccordions = document.querySelectorAll('[data-tab="engineer"]');
  const directorAccordions = document.querySelectorAll('[data-tab="director"]');
  
  if (!engineerTab || !directorTab || !engineerAccordions.length || !directorAccordions.length) {
    return;
  }

  // 現在のアクティブタブ
  let currentTab = 'engineer';

  // 初期化
  function init() {
    setActiveTab('engineer');
    updateAccordionVisibility('engineer');
    engineerTab.addEventListener('click', () => handleTabClick('engineer'));
    directorTab.addEventListener('click', () => handleTabClick('director'));
    setupAccordionEvents();
  }

  // タブクリック処理
  function handleTabClick(tabType) {
    setActiveTab(tabType);
    updateAccordionVisibility(tabType);
  }

  // アクティブタブ設定
  function setActiveTab(tabType) {
    currentTab = tabType;
    updateTabAppearance(tabType);
  }

  // タブの見た目更新
  function updateTabAppearance(tabType) {
    engineerTab.classList.toggle('is-active', tabType === 'engineer');
    directorTab.classList.toggle('is-active', tabType === 'director');
  }

  // アコーディオンの表示/非表示を更新
  function updateAccordionVisibility(tabType) {
    engineerAccordions.forEach(accordion => {
      const shouldShow = tabType === 'engineer';
      accordion.classList.toggle('is-visible', shouldShow);
      accordion.style.display = shouldShow ? 'block' : 'none';
      if (!shouldShow) closeAccordion(accordion);
    });
    
    directorAccordions.forEach(accordion => {
      const shouldShow = tabType === 'director';
      accordion.classList.toggle('is-visible', shouldShow);
      accordion.style.display = shouldShow ? 'block' : 'none';
      if (!shouldShow) closeAccordion(accordion);
    });
  }

  // アコーディオンイベント設定
  function setupAccordionEvents() {
    const allAccordions = [...engineerAccordions, ...directorAccordions];
    
    allAccordions.forEach(accordion => {
      const button = accordion.querySelector('.p-recruit-requirements__item');
      if (button) {
        button.addEventListener('click', () => toggleAccordion(accordion));
      }
    });
  }

  // アコーディオンの開閉切り替え
  function toggleAccordion(accordion) {
    const isOpen = accordion.classList.contains('is-open');
    
    if (isOpen) {
      closeAccordion(accordion);
    } else {
      openAccordion(accordion);
    }
  }

  // 他のアコーディオンを全て閉じる
  function closeAllOtherAccordions(currentAccordion) {
    const allAccordions = [...engineerAccordions, ...directorAccordions];
    allAccordions.forEach(accordion => {
      if (accordion !== currentAccordion && accordion.classList.contains('is-open')) {
        closeAccordion(accordion);
      }
    });
  }

  // アコーディオンを開く
  function openAccordion(accordion) {
    const content = accordion.querySelector('.p-recruit-requirements__content');
    const button = accordion.querySelector('.p-recruit-requirements__item');
    
    accordion.classList.add('is-open');
    button.classList.add('is-active');
    content.classList.add('is-active');
    content.style.maxHeight = content.scrollHeight + 'px';
    
    // ScrollTriggerを更新
    setTimeout(() => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }, 300);
  }

  // アコーディオンを閉じる
  function closeAccordion(accordion) {
    const content = accordion.querySelector('.p-recruit-requirements__content');
    const button = accordion.querySelector('.p-recruit-requirements__item');
    
    accordion.classList.remove('is-open');
    button.classList.remove('is-active');
    content.classList.remove('is-active');
    content.style.maxHeight = '0px';
    
    // ScrollTriggerを更新
    setTimeout(() => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }, 300);
  }

  // 初期化実行
  init();
} 